<ng-container *ngIf="guest$ | async as guest">
  <app-avatar
    [backgroundColor]="backgroundColor"
    [size]="imageSize"
    [circle]="imageCircle"
    [text]="guest.name"
    *ngIf="image"
  ></app-avatar>
  <div
    class="text-truncate"
    [matTooltip]="guest.name"
    matTooltipPosition="above"
    [matTooltipDisabled]="tooltipDisabled"
  >
    {{ guest.name }}
  </div>
</ng-container>
